$(document).ready(function () {
  $('.product-details-accordians-wrapper .exapnd').on('click', function () {
    var $button = $(this);
    var $content = $button.next('.accordion-content');

    // Collapse all other contents
    $('.product-details-accordians-wrapper .accordion-content').not($content).removeClass('active').css('max-height', '0');
    $('.product-details-accordians-wrapper .exapnd').not($button).attr('aria-expanded', 'false');

    // Toggle current content
    var isExpanded = $button.attr('aria-expanded') === 'true';
    $button.attr('aria-expanded', !isExpanded);
    
    if (!isExpanded) {
      $content.addClass('active');
      var scrollHeight = $content[0].scrollHeight;
      $content.css('max-height', scrollHeight + 'px');
    } else {
      $content.removeClass('active').css('max-height', '0');
    }
  });
});